import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/comverse-baseapp-next/app/pages/not-foundPage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/comverse-baseapp-next/components/CollectionPage/CollectionPageAlfa.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/comverse-baseapp-next/components/ProductPage/ProductPage.jsx");
;
import(/* webpackMode: "eager" */ "/home/janab/freelance/comverse-baseapp-next/components/scrollToTopHook/ScrollToTop.jsx");
